import { AccessLevelEnum } from '@zaoblako/shared/modules/security/enums/access.level.enum';
import { PacsAccessRulesKeyEnum } from '@zaoblako/web/core/models/enums/access-rules/pacs/pacs-access-rules-key.enum';

type AccessRuleExpression = Record<string, any>;

export const PacsAccessRulesConst: Record<PacsAccessRulesKeyEnum, AccessRuleExpression> = {
  // --- Модуль PHYSICAL_ACCESS_CONTROL (Пропуска) ---
  // --- Раздел PHYSICAL_ACCESS_CONTROL.SECTIONS.PACS ---

  [PacsAccessRulesKeyEnum.PACS_PACS_ENABLED]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true
  },

  [PacsAccessRulesKeyEnum.PACS_PACS_EQUIPMENT_READ]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PACS.tabs.EQUIPMENT.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [PacsAccessRulesKeyEnum.PACS_PACS_EQUIPMENT_WRITE]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PACS.tabs.EQUIPMENT.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [PacsAccessRulesKeyEnum.PACS_PACS_EVENT_REPORT_READ]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PACS.tabs.EVENT_REPORT.accessLevel': { $gte: AccessLevelEnum.READ }
  },

  [PacsAccessRulesKeyEnum.PACS_PACS_COMING_GOING_READ]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PACS.tabs.COMING_GOING.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PACS.tabs.COMING_GOING.accessLevel': { $gte: AccessLevelEnum.READ }
  },

  [PacsAccessRulesKeyEnum.PACS_PACS_PHOTO_VERIFICATION_READ]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PACS.tabs.PHOTO_VERIFICATION.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PACS.tabs.PHOTO_VERIFICATION.accessLevel': { $gte: AccessLevelEnum.READ }
  },

  [PacsAccessRulesKeyEnum.PACS_PACS_ACCESS_CARD_CONTROL_READ]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PACS.tabs.ACCESS_CARD_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PACS.tabs.ACCESS_CARD_CONTROL.accessLevel': { $gte: AccessLevelEnum.READ }
  },

  [PacsAccessRulesKeyEnum.PACS_PACS_ACCESS_CARD_READ]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PACS.tabs.ACCESS_CARD.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [PacsAccessRulesKeyEnum.PACS_PACS_ACCESS_CARD_WRITE]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PACS.tabs.ACCESS_CARD.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [PacsAccessRulesKeyEnum.PACS_PACS_PASSAGE_TASK_READ]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PACS.tabs.PASSAGE_TASK.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [PacsAccessRulesKeyEnum.PACS_PACS_PASSAGE_TASK_WRITE]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PACS.tabs.PASSAGE_TASK.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [PacsAccessRulesKeyEnum.PACS_PACS_PASSAGE_ORDER_READ]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PACS.tabs.PASSAGE_ORDER.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [PacsAccessRulesKeyEnum.PACS_PACS_PASSAGE_ORDER_WRITE]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PACS.tabs.PASSAGE_ORDER.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [PacsAccessRulesKeyEnum.PACS_PACS_PASSAGE_ORDER_EMPLOYEE_READ]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PACS.tabs.PASSAGE_ORDER_EMPLOYEE.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [PacsAccessRulesKeyEnum.PACS_PACS_PASSAGE_ORDER_EMPLOYEE_WRITE]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PACS.tabs.PASSAGE_ORDER_EMPLOYEE.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  // Разрешения
  [PacsAccessRulesKeyEnum.PACS_PACS_OPEN_DOORS]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PACS.permissions.OPEN_DOORS.isAllowed': true
  },
  [PacsAccessRulesKeyEnum.PACS_PACS_SYNCHRONIZE_CONVERTERS]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PACS.permissions.SYNCHRONIZE_CONVERTERS.isAllowed': true
  },
  [PacsAccessRulesKeyEnum.PACS_PACS_ACCESS_TO_ALL_ROOMS]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PACS.permissions.ACCESS_TO_ALL_ROOMS.isAllowed': true
  },
  [PacsAccessRulesKeyEnum.PACS_PACS_EXTERNAL_USER_BLOCK_PACS_ACCESS]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PACS.permissions.EXTERNAL_USER_BLOCK_PACS_ACCESS.isAllowed': true
  }
};
